import { all } from 'redux-saga/effects';

import loginSagas from 'src/app/redux/sagas/login';
import offersSaga from 'src/app/redux/sagas/offersSaga';
import resetSagas from 'src/app/redux/sagas/reset';
import apiErrorsSaga from 'src/app/redux/sagas/apiErrorSaga';
import transclusionSaga from 'src/app/redux/sagas/transclusionSaga';
import registrationSagas from 'src/app/redux/sagas/registration';
import registrationTrackerSaga from 'src/app/redux/sagas/registrationTrackerSaga';
import authorizeSaga from 'src/app/redux/sagas/authorizeSaga';


export default function* rootSaga() {
  yield all([
    ...loginSagas,
    ...offersSaga,
    ...resetSagas,
    ...registrationSagas,
    ...apiErrorsSaga,
    ...transclusionSaga,
    ...registrationTrackerSaga,
    ...authorizeSaga
  ]);
}
